import { Box, Flex } from '@chakra-ui/react';

import {
  ExtremelyHelpful,
  ExtremelyUnhelpful,
  Helpful,
  SomewhatHelpful,
  SomewhatUnhelpful,
} from 'assets/assetsV1/iconComponents';

import { InputV2 } from 'uiToolkitV1/InputV2';

import { EngagementAnswerOptions } from '../slice/AddEngagementQuestion.slice';

const EMOJI_ICONS = {
  5: <ExtremelyHelpful boxSize="40px" color="#0D819F" />,
  4: <SomewhatHelpful boxSize="40px" color="#0D819F" />,
  3: <Helpful boxSize="40px" color="#0D819F" />,
  2: <SomewhatUnhelpful boxSize="40px" color="#0D819F" />,
  1: <ExtremelyUnhelpful boxSize="40px" color="#0D819F" />,
};

type EmojiScaleProps = {
  scale?: 3 | 4 | 5; // The scale can be 3, 4, or 5
  answerOptions?: EngagementAnswerOptions; // Array of descriptions for each emoji
  onDescriptionChange: (index: number, value: string) => void; // Callback for description changes
};

const EmojiScale = ({ scale = 3, answerOptions = [], onDescriptionChange }: EmojiScaleProps) => {
  // Generate the emoji indices based on the scale
  const getEmojiArray = () => {
    if (scale === 3) return [1, 3, 5];
    if (scale === 4) return [1, 2, 4, 5];
    return [1, 2, 3, 4, 5];
  };

  const emojiArray = getEmojiArray();

  return (
    <Flex gap="16px">
      {/* Emoji Row */}
      <Flex flexDir="column" gap="16px" w="100%">
        {emojiArray.map((emojiIndex, i) => (
          <Flex key={answerOptions[i]?.score} alignItems="center" gap="16px" w="100%">
            <Box textAlign="center">{EMOJI_ICONS[emojiIndex]}</Box>
            <InputV2
              isDashed
              placeholder="Enter label"
              value={answerOptions[i]?.description ?? ''}
              onChange={(e) => onDescriptionChange(i, e.target.value)}
              style={{ width: '100%' }}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export { EmojiScale };
